import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';
import { RPE_INTENSITY_RANGES } from '../../../utils/trainingLoadCalculations';

const TrainingLoadACWRChart = ({ data, title, width = 678, height = 300 }) => {
  return (
    <div style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
      <ComposedChart 
        width={width} 
        height={height} 
        data={data}
        margin={{ top: 5, right: 50, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
        <XAxis 
          dataKey="date" 
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          interval="preserveStartEnd"
        />
        <YAxis 
          yAxisId="load"
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          label={{ value: 'Load (AU)', angle: -90, position: 'insideLeft', dx: 14, style: { fontSize: '11px', textAnchor: 'middle' } }}
        />
        <YAxis 
          yAxisId="ratio"
          orientation="right"
          domain={[0, 2]}
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          label={{ value: 'ACWR', angle: 90, position: 'insideRight', dx: -20, style: { fontSize: '11px', textAnchor: 'middle' } }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }}
          iconType="rect"
        />
        <Bar 
          yAxisId="load" 
          dataKey="lowLoad" 
          stackId="load" 
          fill={RPE_INTENSITY_RANGES?.LOW?.color}
          name="Low (RPE 1-3)"
        />
        <Bar 
          yAxisId="load" 
          dataKey="moderateLoad" 
          stackId="load" 
          fill={RPE_INTENSITY_RANGES?.MODERATE?.color}
          name="Moderate (RPE 4-6)"
        />
        <Bar 
          yAxisId="load" 
          dataKey="highLoad" 
          stackId="load" 
          fill={RPE_INTENSITY_RANGES?.HIGH?.color}
          name="Hard (RPE 7-10)"
        />
        <Line 
          yAxisId="ratio" 
          type="monotone" 
          dataKey="displayRatio" 
          stroke="#8B5CF6" 
          strokeWidth={2} 
          dot={{ r: 3 }}
          name="ACWR"
        />
      </ComposedChart>
    </div>
  );
};

export default TrainingLoadACWRChart;